import { nftMap } from '@/utils/abi'

export const SYNTH_CONFIG_BASE = [
  {
    type: 1,
    info: nftMap['1']
  },
  {
    type: 2,
    info: nftMap['2']
  },
  {
    type: 3,
    info: nftMap['3']
  },
  {
    type: 4,
    info: nftMap['4']
  }
]


export const SYNTH_CONFIG_GENIE = SYNTH_CONFIG_BASE.concat({
  type: [5, 6],
  info: nftMap['5']
})

export const SYNTH_CONFIG_KNIGHT = SYNTH_CONFIG_BASE.concat([
  {
    type: 5,
    info: nftMap['5']
  },
  {
    type: 6,
    info: nftMap['6']
  }
])